/**
 * to prevents the event-flow from bubbling up to parent elements
 * @param event event of the selected element,
 */
export const cancelEventBubble = (event) => {
  event.cancelBubble = true;
  if (event.stopPropagation) event.stopPropagation();
};
